import { sanitizeHtml } from '../HtmlEditor/htmlDocument';

/**
 * HTML an extension previews in the page itself, not in an editor's frame
 * (I-2799). The editor's sanitizer keeps style elements for its frame; in the
 * page they would restyle the whole app, so they go. Inline styles stay — the
 * preview box contains them (`contain: layout paint`).
 */
export function richTextPreviewHtml(html: string): string {
  const doc = new DOMParser().parseFromString(sanitizeHtml(html, false), 'text/html');
  doc.body.querySelectorAll('style, link, meta, base').forEach((element) => element.remove());
  return doc.body.innerHTML;
}
